import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import './CustomerTestimonialPage.css';
import { ReactComponent as BackArrow } from '../../../assets/left_arrow_black.svg';
import Button from '../../../components/button/Button';
import ReferralBannerUrl from '../../../assets/webp-images/customer_testimonial.webp';
import { Mixpanel } from '../../../analytics/Mixpanel';
import { useSelector } from 'react-redux';

interface CustomerTestimonialPageProps {
	onCustomerTestimonialPageContinueHandler: () => void;
	onBackArrowClick: () => void;
	selectedExperienceIndex: number;
}

const CustomerTestimonialPage: React.FC<CustomerTestimonialPageProps> = ({
	onCustomerTestimonialPageContinueHandler,
	onBackArrowClick,
}) => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const onboardingExperimentKey = useSelector(
		(state: any) => state.abExperiment.data.onboarding_experiment_key
	);

	let subtitle = 'Neelakshi';
	let description =
		'Thanks to Seek, I have become stronger, more fearless and can handle any life situation with grace.';

	useEffect(() => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading:
				'We work on body, breath and mind to provide you the best outcomes',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: onboardingExperimentKey,
		});
	}, []);

	return (
		<Container className={'customer-testimonial-page-container'}>
			<div className={'customer-testimonial-header-container'}>
				<BackArrow onClick={onBackArrowClick} width={48} height={48} />
				{/*<span className={'ques-header-title'}>1.  Knowing your preferences</span>*/}
				<div />
			</div>
			<p className={'customer-testimonial-title'}>
				{'We work on body, breath and mind to provide you the best outcomes'}
			</p>
			<svg
				style={{ marginTop: '-36px', marginLeft: '48px' }}
				xmlns='http://www.w3.org/2000/svg'
				width='188'
				height='24'
				viewBox='0 0 188 24'
				fill='none'>
				<mask
					id='mask0_335_3706'
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='188'
					height='24'>
					<path d='M188 0.215202H0V23.7747H188V0.215202Z' fill='white' />
				</mask>
				<g mask='url(#mask0_335_3706)'>
					<path
						d='M2.5281 14.6923C-0.0304914 13.5843 0.35833 12.5882 3.69458 11.7039C7.03084 10.8195 12.5637 10.2515 20.2931 9.99961C22.0035 9.98111 23.6584 9.97372 25.2578 9.97745C26.9682 9.95895 28.2526 9.89073 29.1111 9.77278C30.0218 9.75242 32.3949 9.70922 36.2301 9.6432C40.258 9.59262 45.0448 9.52507 50.5905 9.44055C56.2179 9.3937 62.0524 9.33234 68.0943 9.25647C74.2177 9.21828 79.9413 9.17915 85.265 9.13909C90.6996 9.07679 95.2235 9.03487 98.8376 9.01331C102.451 8.99175 104.449 8.99641 104.836 9.0273C105.05 9.20022 105.654 9.29534 106.647 9.31264C107.831 9.34539 108.853 9.3028 109.711 9.18486C110.763 9.08235 111.991 9.02524 113.398 9.01353C114.887 9.03949 115.905 9.10559 116.453 9.21182C117.171 9.17601 117.986 9.14793 118.896 9.12756C119.889 9.14487 120.647 9.1279 121.173 9.07664C121.698 9.02539 122.25 9.02293 122.828 9.06926C123.516 9.09335 124.125 9.07978 124.649 9.02853C126.301 9.12984 128.712 9.21417 131.88 9.28154C135.161 9.32667 138.842 9.37273 142.921 9.41973C147.084 9.50441 151.26 9.55912 155.452 9.58389C159.724 9.64633 163.707 9.68561 167.402 9.70172C171.097 9.71784 174.2 9.71757 176.71 9.70094C179.219 9.6843 180.738 9.65036 181.262 9.59911C183.173 9.37866 184.654 9.62201 185.709 10.3291C186.561 10.4286 187.324 10.7077 188 11.1666C188 11.1666 187.804 11.2599 187.412 11.4464C187.212 11.6483 186.843 11.9923 186.304 12.4783C185.877 12.9421 185.123 13.2552 184.043 13.4176C183.045 13.6177 181.812 13.7835 180.346 13.915C178.74 14.1287 177.177 14.2525 175.66 14.2864C174.253 14.2981 172.076 14.2481 169.129 14.1362C166.293 14.0022 161.83 13.8156 155.744 13.5765C154.254 13.5506 152.726 13.5057 151.156 13.4421C149.778 13.3939 148.456 13.3346 147.19 13.2642C146.115 13.2092 145.179 13.1808 144.379 13.1789C143.69 13.1548 143.235 13.165 143.013 13.2095C142.487 13.2607 141.536 13.2622 140.159 13.2141C138.974 13.1813 137.526 13.1742 135.817 13.1927C134.55 13.1223 132.732 13.0543 130.362 12.9888C127.992 12.9233 125.526 12.8501 122.964 12.7691C120.483 12.7259 118.25 12.6869 116.267 12.6523C114.392 12.5955 113.344 12.5893 113.122 12.6337C112.708 12.6628 112.198 12.6841 111.59 12.6976C111.064 12.7489 110.431 12.7137 109.691 12.592C109.474 12.4191 108.953 12.3617 108.124 12.4197C107.488 12.4931 107.17 12.5299 107.17 12.5299C106.281 12.7078 102.502 12.7627 95.8291 12.6946C92.7126 12.7248 88.0364 12.7702 81.802 12.8306C75.6492 12.9287 68.793 13.0326 61.2333 13.1425C53.8662 13.2677 46.5954 13.4007 39.4208 13.5414C32.3574 13.6598 26.2454 13.7768 21.0848 13.8922C16.0058 14.0453 12.7743 14.2064 11.3902 14.3756C8.51115 14.7362 6.56078 14.9378 5.53911 14.9804C4.40644 15.0452 3.40277 14.9492 2.5281 14.6923Z'
						fill='#FAA53D'
					/>
				</g>
			</svg>

			<div className={'customer-testimonial-body-container'}>
				<p className={'customer-testimonial-name'}>{subtitle}</p>
				<p className={'customer-testimonial-description'}>{description}</p>
				<div
					style={{ position: 'relative', marginTop: '44px', display: 'flex' }}>
					<img
						src={ReferralBannerUrl}
						alt='Referral Banner'
						style={{
							width: '64px',
							height: '64px',
							borderRadius: '50%',
							zIndex: 5,
						}}
					/>
					{/*<div style={{position: "absolute", top: -2, left: -2, right: -2, bottom: -2, border: "2px solid #FAA53D", opacity: '0.1', borderRadius: "50%"}}></div>*/}
					<div
						style={{
							position: 'absolute',
							top: -12,
							left: -12,
							right: -12,
							bottom: -12,
							border: '2px solid #FAA53D',
							opacity: '1',
							borderRadius: '50%',
						}}></div>
					{/* Yellowish background div */}
					<div
						style={{
							position: 'absolute',
							top: -12,
							left: -12,
							right: -12,
							bottom: -12,
							opacity: '0.24',
							backgroundColor: '#FAA53D',
							borderRadius: '50%',
						}}></div>
					<div
						style={{
							position: 'absolute',
							top: -24,
							left: -24,
							right: -24,
							bottom: -24,
							border: '2px solid #4462EF',
							opacity: '0.6',
							borderRadius: '50%',
						}}></div>
					<div
						style={{
							position: 'absolute',
							top: -36,
							left: -36,
							right: -36,
							bottom: -36,
							border: '2px solid #4462EF',
							opacity: '0.3',
							borderRadius: '50%',
						}}></div>
					<div
						style={{
							position: 'absolute',
							top: -48,
							left: -48,
							right: -48,
							bottom: -48,
							border: '2px solid #4462EF',
							opacity: '0.2',
							borderRadius: '50%',
						}}></div>
					<div
						style={{
							position: 'absolute',
							top: -60,
							left: -60,
							right: -60,
							bottom: -60,
							border: '2px solid #4462EF',
							opacity: '0.1',
							borderRadius: '50%',
						}}></div>
				</div>
			</div>
			<Button
				isSticky={true}
				style={{ alignSelf: 'center', marginBottom: '24px' }}
				onClick={onCustomerTestimonialPageContinueHandler}
				label={'Continue'}></Button>
		</Container>
	);
};

export default CustomerTestimonialPage;
